import { HttpError } from "@/http-error";

const retryCodes = [408, 425, 429, 500, 502, 503, 504];

export function retryFunc(failureCount: number, error: unknown) {
  if (
    error instanceof HttpError &&
    !retryCodes.includes(error.status)
  ) {
    return false;
  }


  if (failureCount > 3) {
    return false;
  }

  return true;
}
